import { labelingContextViewAtom } from "../state";
import { useAtomValue } from "jotai";
import { AccountCreation } from "./AccountCreation";
import { DraftCommit } from "./DraftCommit/DraftCommit";
import { AccountList } from "./AccountList";
import { AccountEditForm } from "./AccountEditForm";

export function LabelingContextPanel() {
    const labelingContextView = useAtomValue(labelingContextViewAtom);

    if (
        labelingContextView?.type === "ACCOUNT_SELECTION_LIST" ||
        labelingContextView?.type === "ACCOUNT_LIST_EDIT"
    ) {
        return <AccountList />;
    }
    if (labelingContextView?.type === "ACCOUNT_SELECTION_NEW") {
        return <AccountCreation />;
    }
    if (labelingContextView?.type === "DRAFT_COMMIT") {
        return <DraftCommit />;
    }

    if (labelingContextView?.type === "ACCOUNT_EDIT") {
        return <AccountEditForm initial={labelingContextView.initial} />;
    }

    return null;
}
